module.exports = __webpack_public_path__ + "63010b458074cf1203325b734f460603.png";